export default function About() {
  return (
    <section className="py-20 bg-gradient-to-b from-slate-800 to-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-5xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent mb-6 font-playfair">
            Sobre MAR AZUL
          </h3>
          <div className="w-24 h-1 bg-gradient-to-r from-cyan-400 to-blue-400 mx-auto mb-6 rounded-full"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h4 className="text-3xl font-bold text-white mb-6">
              Líderes en Renta de Lanchas y Yates en Los Cabos
            </h4>
            <p className="text-lg text-gray-300 mb-6 leading-relaxed">
              <strong>MAR AZUL</strong> es la empresa líder en renta de lanchas y yates en Cabo San Lucas, 
              especializada en ofrecer experiencias náuticas únicas en las cristalinas aguas del Mar de Cortés. 
              Con más de una década de experiencia, nos hemos posicionado como la opción preferida para 
              turistas y locales que buscan aventuras marinas inolvidables.
            </p>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed">
              Nuestra flota de embarcaciones de lujo incluye desde lanchas familiares hasta mega yates, 
              todos mantenidos con los más altos estándares de calidad y seguridad. En <strong>MAR AZUL</strong>, 
              transformamos cada salida en una experiencia extraordinaria con servicios personalizados 
              y atención de primera clase.
            </p>
          </div>
          
          <div className="relative">
            <div className="relative h-96 overflow-hidden rounded-2xl border border-cyan-500/20">
              <img
                alt="VIP Cabo Yacht Rentals - Experiencia de lujo"
                className="w-full h-full object-cover object-center transform hover:scale-105 transition-transform duration-500"
                src="https://public.readdy.ai/ai/img_res/88d86a629427a6a04eaa842a8dd5fff6.jpg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="bg-slate-800/50 backdrop-blur-xl rounded-2xl border border-cyan-500/20 p-8 text-center transform hover:scale-105 transition-all">
            <div className="w-20 h-20 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-award-line text-3xl text-white"></i>
            </div>
            <h5 className="text-2xl font-bold text-white mb-4">Experiencia</h5>
            <p className="text-gray-300">
              Más de 10 años liderando el mercado náutico de lujo en Los Cabos con miles de clientes satisfechos.
            </p>
          </div>
          
          <div className="bg-slate-800/50 backdrop-blur-xl rounded-2xl border border-cyan-500/20 p-8 text-center transform hover:scale-105 transition-all">
            <div className="w-20 h-20 bg-gradient-to-r from-teal-400 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-ship-2-line text-3xl text-white"></i>
            </div>
            <h5 className="text-2xl font-bold text-white mb-4">Flota Premium</h5>
            <p className="text-gray-300">
              La flota más exclusiva de Los Cabos con mega yates Ferretti, Azimut y embarcaciones especializadas.
            </p>
          </div>
          
          <div className="bg-slate-800/50 backdrop-blur-xl rounded-2xl border border-cyan-500/20 p-8 text-center transform hover:scale-105 transition-all">
            <div className="w-20 h-20 bg-gradient-to-r from-orange-400 to-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-customer-service-2-line text-3xl text-white"></i>
            </div>
            <h5 className="text-2xl font-bold text-white mb-4">Servicio VIP</h5>
            <p className="text-gray-300">
              Atención personalizada 24/7 con tripulación profesional certificada y servicios todo incluido.
            </p>
          </div>
        </div>

        {/* Statistics */}
        <div className="bg-gradient-to-r from-cyan-500/10 to-blue-500/10 backdrop-blur-xl rounded-2xl border border-cyan-500/30 p-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent mb-2">
                50+
              </div>
              <div className="text-gray-300">Yates en Flota</div>
            </div>
            <div>
              <div className="text-4xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent mb-2">
                10,000+
              </div>
              <div className="text-gray-300">Clientes Felices</div>
            </div>
            <div>
              <div className="text-4xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent mb-2">
                10+
              </div>
              <div className="text-gray-300">Años Experiencia</div>
            </div>
            <div>
              <div className="text-4xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent mb-2">
                98%
              </div>
              <div className="text-gray-300">Satisfacción</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}